export default { showCountdown: false, activeYear: '2026' }
